import React, { useState } from 'react';
import styled from 'styled-components';
import Badge from './Badge';
import GazhLogo_w from '../assets/GazhLogo_w.png';
import { RiHomeLine, RiFileCopyLine, RiCopperCoinFill, RiCastFill, RiStore2Line, RiGift2Fill, RiHome2Fill, RiDashboardFill, RiCoinsFill, RiProfileLine, RiLockPasswordFill } from 'react-icons/ri';
import { FaBars, FaWallet } from 'react-icons/fa';
import { HiDocumentText } from 'react-icons/hi';
import { DarkThemeColor } from '../utils';
import { IoCloseOutline } from 'react-icons/io5';
import { IoMdArrowRoundBack } from "react-icons/io";
import { MdQuiz, MdOutlineUpcoming, MdConnectWithoutContact, MdPersonAddAlt1, MdMessage } from "react-icons/md";
import AttractionsIcon from '@mui/icons-material/Attractions';
import { withRouter } from 'react-router-dom';
import { deleteAuthenticationToken, getAuthenticationToken } from '../utils/TokenHandler'
import { getUserProfile } from '../utils/userProfile';
import { Avatar } from '@mui/material';

function Sidebar(props) {
    const { history } = props;
    const { location } = props;
    const [isActive, setActive] = useState(false);
    const MyContainer = styled.div`
        width:20%;
        border-radius: 0 2rem 2rem 0;
        background-color:#091322;
        display:flex;
        flex-direction:column;
        align-items:center;
        gap:3rem;
        @media screen and (min-width: 1081px) and (max-width: 1920px){
            width: 25%;
        }
        @media screen and (min-width: 320px) and (max-width: 1080px){
            width: 100%;
            height: 100%;
            border-radius: 2rem;
            display:${isActive ? 'flex' : 'none'};
        }
    `;


    const HamburgerMenu = styled.div`
        svg{
            display:none;
        }
        @media screen and (min-width: 320px) and (max-width: 1080px){
            width: 100%;
            svg{
                font-size: 2.3rem;
                margin:1rem 2rem 0 0;
                color: white;
                border:1px solid white;
                border-radius:0.4rem;
                padding:0.3rem;
                display:flex;
            }
        }
    `;

    const BackMenu = styled.div`
        svg{
            display:none;
        }
        @media screen and (min-width: 320px) and (max-width: 1080px){
            svg{
                display:block;
            }
        }
    `;
    const backBtnStyle = {
        position: 'absolute',
        left: '30px',
        top: '40px',
        fontSize: '30px',
        color: 'white',
        cursor: 'pointer'
    }

    const userProfile = getUserProfile();
    let userId = getAuthenticationToken().userID;
    const isAdminUser = (userId == 2214 || userId == 10) ?
        <Link onClick={() => { history.push('/checkSerialNumber') }}>
            <HiDocumentText />
            <h3> چک کردن سریال</h3>
        </Link> :
        <></>

    return (
        <>
            <HamburgerMenu onClick={() => {
                setActive(!isActive);
            }}>
                {isActive ? <IoCloseOutline /> : <FaBars />}
            </HamburgerMenu>
            {location.pathname === '/' ? <span></span> :
                <BackMenu>
                    <IoMdArrowRoundBack onClick={() => { history.push('/') }} style={backBtnStyle} />
                </BackMenu>}
            <MyContainer>
                <ProfileContainer>
                    <Avatar style={AvatarStyle} src={userProfile.profileCDNImage} />
                    <Name>{userProfile.customerName}</Name>
                    <UserName>{userProfile.customerUserName}</UserName>
                    <Badge onClick={() => {
                        deleteAuthenticationToken();
                        history.push('/loginbymobile');
                    }} content="خروج" />
                </ProfileContainer>
                <LinkContainer>
                    <Links>
                        <Link onClick={() => { history.push('/') }}>
                            <RiDashboardFill style={{ color: '#fff' }} />
                            <h3 style={{ color: '#fff' }} >داشبورد</h3>
                        </Link>
                        <Link onClick={() => { history.push('/userprofile') }}>
                            <RiProfileLine />
                            <h3>مشخصات</h3>
                        </Link>
                        <Link onClick={() => { history.push('/scoredetail') }}>
                            <RiCopperCoinFill />
                            <h3>امتیازات</h3>
                        </Link>
                        <Link onClick={() => { history.push('/lotteries') }}>
                            <RiGift2Fill />
                            <h3>قرعه کشی</h3>
                        </Link>
                        {/* <Link onClick={() => { history.push('/merchantlotteries') }}>
                            <MdQuiz />
                            <h3>آزمون ها</h3>
                        </Link> */}
                        <Link onClick={() => { history.push('/customerrepresenter') }}>
                            <MdConnectWithoutContact />
                            <h3>معرفی دوستان</h3>
                        </Link>
                        <Link onClick={() => { history.push('/customerrepresenteradd') }}>
                            <MdPersonAddAlt1 />
                            <h3>ثبت معرف</h3>
                        </Link>
                        <Link onClick={() => { history.push('/customeraddtoolsserial') }}>
                            <MdOutlineUpcoming />
                            <h3>ثبت کد محصول</h3>
                        </Link>
                        <Link onClick={() => { history.push('/supportsystemticketing') }}>
                            <MdMessage />
                            <h3>پیام ها</h3>
                        </Link>
                        <Link onClick={() => { history.push('/changepassword') }}>
                            <RiLockPasswordFill />
                            <h3>تغییر پسورد</h3>
                        </Link>
                        <Link onClick={() => { history.push('/wheel') }}>
                            <AttractionsIcon />
                            <h3> گردونه شانس</h3>
                        </Link>
                        {isAdminUser}
                        {/* <Link>
                            <HiDocumentText />
                            <h3>قرارداد</h3>
                        </Link>
                        <Link>
                            <FaWallet />
                            <h3>کیف پول</h3>
                        </Link> */}
                    </Links>
                    <ContactContainer>
                        <span>طراحی و اجرا</span>
                        <a href="https://www.gazh.ir/">گسترش ارتباطات ژرف</a>
                    </ContactContainer>
                </LinkContainer>
            </MyContainer>
        </>
    );
}

const ProfileContainer = styled.div`
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

const AvatarStyle = {
    height: '6rem',
    width: '6rem',
    marginTop: '10%'
};

const Name = styled.h1`
    color: white;
    font: 1.2rem;
    font-weight: 400;
    margin: 0.5rem 0 0.5rem 0;
`;

const UserName = styled.h4`
    color: #bcbcbc;
    font: 1rem;
    font-weight: 800;
    margin: 0.3rem 0 0.5rem 0;
    direction:ltr !important;
`;

const LinkContainer = styled.div`
    background-color:${DarkThemeColor};
    height:100%;
    width:100%;
    border-radius: 0 0 2rem 0;
    @media screen and (min-width: 320px) and (max-width: 1080px){
        border-radius: 2rem;
    }
`;

const Links = styled.ul`
    list-style-type: none;
    display: flex;
    flex-direction: column;
    padding-top: 1.3rem;
`;

const Link = styled.li`
    margin-right: 25%;
    margin-bottom: 0.5rem;
    display:flex;
    gap: 0.7rem;
    color: #e4e4e4;
    cursor: pointer;
    h3{
        font-weight: 200;
        font-size:smaller;
    }
    svg{
        font-size: 1.5rem;
    }
`;

const ContactContainer = styled.div`
    width: 60%;
    background-color: #091322;
    color: #e4e4e4;
    height: max-content;
    margin: auto auto;
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    padding: 1rem;
    text-align:center;
    font-size:small;
    a{
        color:white;
        text-decoration: none;
        font-size:small;
    }
    img{
        width:60px;
        height:60px;
        margin:auto;
    }
    @media screen and (min-width: 320px) and (max-width: 1080px){
        margin:auto;
    }
`;
export default withRouter(Sidebar);